import React from "react";
import styles from "./style.module.css"; // Import custom CSS for styling
import { useTheme } from "styled-components";

const CustomToggleSwitch = ({ checked, onChange, label }) => {
  const theme = useTheme();

  return (
    <div className={styles.toggle_container}>
      {label && (
        <span className={styles.label} style={{ color: theme.black }}>
          {label}
        </span>
      )}
      <label className={styles.switch}>
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span className={`${styles.slider} ${styles.round}`}></span>
      </label>
    </div>
  );
};

export default CustomToggleSwitch;
